import { Component, Input } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FilterFieldComponent } from '../filter-field.component';
import { TabbedFilterField } from './filter-field-tabbed';

export type TabFilterTheme = 'gradient' | 'plain';

@Component({
  selector: 'va-filter-tabbed',
  templateUrl: './filter-field-tabbed.component.html',
  styleUrls: ['filter-field-tabbed.component.scss'],
  standalone: false,
})
export class TabbedFilterFieldComponent extends FilterFieldComponent<TabbedFilterField> {
  @Input() useCustomCase = false;
  @Input() theme: TabFilterTheme = 'gradient';
  changeTab(event: MatTabChangeEvent): void {
    const tab = this.filterField.options[event.index];
    this.applyFilter(tab);
  }

  get selectedIndex(): number {
    if (this.filterField.value) {
      return this.filterField.options.findIndex((tab) => tab.id === this.filterField.value?.id || '');
    }
    return 0;
  }

  getThemeClasses(): string {
    switch (this.theme) {
      case 'gradient':
        return 'tab-container gradient';
      case 'plain':
        return 'plain';
    }
  }
}
